import './App.css';
import Hero from './sections/hero/hero';
import About from './sections/about/about';
import Partners from './sections/partners/partners';
import Header from './components/header/header';
import { Analytics } from "@vercel/analytics/react"
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Donate from './donate/donate';
import Events from './events/events';
import Store from './sections/storefront/storefront';
import Appreciation from './sections/appreciation/appreciation';
import Console from './console/Console';
import Login from './console/Login';
import Footer from './sections/footer/footer';

function App() {
  return (
    <Router>
      <div className="App">
        <Analytics />
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <section id="hero">
                <Hero />
              </section>
              <section id="about" style={{ paddingTop: '100px' }}>
                <About />
              </section>
              <section id="partners" style={{ paddingTop: '100px' }}>
                <Partners />
              </section>
            </>
          } />
          <Route path="/donate" element={<Donate />} />
          <Route path="/events" element={<Events />} />
          <Route path="/online-ticket" element={<Store />} />
          <Route path="/appreciation" element={<Appreciation />} />
          <Route path="/console" element={<Console />} />
          <Route path="/console/login" element={<Login />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
